
export const vlogDateString = (vlog) => {
  const vlogDate = new Date(vlog.recorded_on_epoch_milliseconds)
  return vlogDate.toLocaleString('default', { month: 'long' }) +
    " " +
   vlogDate.toLocaleString('default', { day: '2-digit' })
}